import _extends from "@babel/runtime/helpers/esm/extends";
var _IconLoading;
// import Modules
import React from 'react';
import { Box } from '@mui/material';
import Typography from "../../atoms/Typography";
import Button from "../../atoms/Button";

// import Styles
import colors from "../../theme/colors";

// import Types
import { IconLoading } from "../../atoms/Icon";
import { formatCurrency, formatCurrencyForTcKo } from "../../utils";
import { checkLocaleHkTw } from "../EStoreBestsellerHome/PopularCard";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SummaryCard = props => {
  const {
    title,
    totalAmount = 0,
    discount = 0,
    quantity = 0,
    totalText,
    shippingText,
    titleTaxForTC,
    locale,
    button,
    disabled = false,
    itemsText,
    itemText,
    onClickedCheckoutButton = () => {},
    discountText,
    submitLoading = false,
    currencySymbol
  } = props;
  let formatedTotalAmount;
  const localeLower = `${locale}`.toLowerCase();
  // Convert from ["tc"].includes(`${locale}`.toLowerCase()) ? `${currencySymbol}${formatCurrencyForTcKo(Math.round((totalAmount - (totalAmount - discount)) || 0))}` : ["ko-kr"].includes(`${locale}`.toLowerCase()) ? `${formatCurrencyForTcKo(Math.round(totalAmount - (totalAmount - discount)))}${currencySymbol}` : `${currencySymbol}${formatCurrency(Math.round(totalAmount - (totalAmount - discount)), 2)}`
  if (["tc"].includes(localeLower)) {
    // For 'tc' locale, calculate the discount explicitly and place the currency symbol before the amount.
    formatedTotalAmount = `${currencySymbol}${formatCurrencyForTcKo(Math.round(totalAmount - (totalAmount - discount) || 0))}`;
  } else if (["ko-kr"].includes(localeLower)) {
    // For 'ko-kr' locale, also calculate the discount explicitly and place the currency symbol after the amount.
    formatedTotalAmount = `${formatCurrencyForTcKo(Math.round(totalAmount - (totalAmount - discount)))}${currencySymbol}`;
  } else {
    // For all other locales, perform the same explicit discount calculation and round to two decimal places.
    formatedTotalAmount = `${currencySymbol}${formatCurrency(totalAmount - (totalAmount - discount), 2)}`;
  }
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      minWidth: {
        xs: '100%',
        md: '357px'
      }
    },
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "h4",
      sx: {
        marginBottom: {
          xs: '36px',
          md: '64px'
        },
        lineHeight: {
          xs: "28px",
          md: "36px"
        }
      },
      children: title
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'space-between'
      },
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "p6",
        color: colors.primary.bandaiNamcoBlack,
        children: `${quantity} ${quantity === 1 ? itemText : itemsText}`
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "p6",
        children:
        // eslint-disable-next-line no-nested-ternary
        ["tc"].includes(`${locale}`.toLowerCase()) ? `${currencySymbol}${formatCurrencyForTcKo(totalAmount)}` : ["ko-kr"].includes(`${locale}`.toLowerCase()) ? `${formatCurrencyForTcKo(totalAmount)}${currencySymbol}` : `${currencySymbol}${formatCurrency(totalAmount, 2)}`
      })]
    }), discount > 0 && discount < totalAmount && /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'space-between'
      },
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "p6",
        color: colors.primary.bandaiNamcoBlack,
        children: discountText
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "p6",
        children:
        // eslint-disable-next-line no-nested-ternary
        `-${["tc"].includes(`${locale}`.toLowerCase()) ? `${currencySymbol}${formatCurrencyForTcKo(Number((totalAmount - discount || 0).toFixed(2)))}` : ["ko-kr"].includes(`${locale}`.toLowerCase()) ? `${formatCurrencyForTcKo(Number((totalAmount - discount).toFixed(2)))}${currencySymbol}` : `${currencySymbol}${formatCurrency(Number((totalAmount - discount).toFixed(2)), 2)}`}`
      })]
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        width: '100%',
        height: '1px',
        background: '#c1c1c1',
        opacity: '0.5',
        margin: {
          xs: '16px 0px',
          md: '28px 0px'
        }
      }
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'space-between'
      },
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          flex: 1
        },
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h6",
          children: totalText
        }), /*#__PURE__*/_jsx(Typography, {
          width: "70%",
          variant: "p8",
          children: shippingText
        }), checkLocaleHkTw(locale) && /*#__PURE__*/_jsx(Typography, {
          color: "Inclusive of tax",
          variant: "p9",
          sx: {
            marginTop: "4px",
            fontSize: {
              md: "12px",
              xs: "10px"
            }
          },
          children: titleTaxForTC
        })]
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "h6",
        children:
        // eslint-disable-next-line no-nested-ternary
        ["tc"].includes(`${locale}`.toLowerCase()) ? `${currencySymbol}${formatCurrencyForTcKo(Number((totalAmount - (totalAmount - discount) || 0).toFixed(2)))}` : ["ko-kr"].includes(`${locale}`.toLowerCase()) ? `${formatCurrencyForTcKo(Number((totalAmount - (totalAmount - discount)).toFixed(2)))}${currencySymbol}` : `${currencySymbol}${formatCurrency(Number((totalAmount - (totalAmount - discount)).toFixed(2)), 2)}`
      })]
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        display: {
          xs: 'none',
          lg: 'block'
        },
        marginTop: {
          lg: '52px'
        },
        '& svg': {
          '& rect': {
            fill: '#fff'
          }
        },
        pointerEvents: submitLoading ? 'none' : 'auto'
      },
      children: /*#__PURE__*/_jsx(Button, _extends({
        onClick: () => onClickedCheckoutButton(true),
        fullWidth: true
      }, button, {
        variant: !disabled ? 'primaryDark' : 'primary',
        disabled: disabled,
        label: submitLoading ? _IconLoading || (_IconLoading = /*#__PURE__*/_jsx(IconLoading, {})) : button.label
      }))
    })]
  });
};
export default SummaryCard;